/* eslint-disable */

import { Attribute } from 'spraypaint';

// Copied from Spraypaint.js.
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf
    || ({ __proto__: [] } instanceof Array && function (d, b) { Object.setPrototypeOf(d, b); })
    || function (d, b) { for (const p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

// Copied from Spraypaint.js.
function __extends(d, b) {
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

// Modeled after Spraypaint.js SingleAssociationBase.
const StringOrNullAttr = (function (_super) {
  __extends(StringOrNullAttr, _super);

  function StringOrNullAttr(options) {
    const _this = _super.call(this, options) || this;
    return _this;
  }

  StringOrNullAttr.prototype.setter = function (context, val) {
    const privateContext = context;
    privateContext._attributes[this.name] = val || null;
  };

  return StringOrNullAttr;
}(Attribute));

const stringOrNullAttr = function (options) {
  return new StringOrNullAttr(options);
};

export default stringOrNullAttr;
